<script>
  import { inertia, page } from '@inertiajs/inertia-svelte'
  import { route } from '@/Utils'
  import Icon from '@/Shared/Icon.svelte'

  $: isUrl = (name, options) => {
    if ($page) {
      return route().current(name, options)
    }
    return false
  }
</script>

<div {...$$restProps}>
  <div class="mb-4">
    <a use:inertia href={route('dashboard')} class="flex items-center group py-3">
      <Icon
        name="dashboard"
        class="w-5 h-5 mr-1 {isUrl('dashboard') ? 'fill-white' : 'fill-disco-200 group-hover:fill-white'} transition duration-500 ease-in-out" />
      <div class="{isUrl('dashboard') ? 'text-white' : 'text-disco-200 group-hover:text-white'} text-sm transition duration-500 ease-in-out">
        Accueil
      </div>
    </a>
  </div>
  <div class="mb-4">
    <a use:inertia href={route('users.addresses', {user: $page.props.auth.user.id})} class="flex items-center group py-3">
      <Icon name="place" class="w-5 h-5 mr-1 {isUrl('users.addresses', {user: $page.props.auth.user.id}) ? 'fill-white' : 'fill-disco-200 group-hover:fill-white'} transition duration-500 ease-in-out" />
      <div class="{isUrl('users.addresses', {user: $page.props.auth.user.id}) ? 'text-white' : 'text-disco-200 group-hover:text-white'} text-sm transition duration-500 ease-in-out">
        Mes adresses
      </div>
    </a>
  </div>
  <div class="mb-4">
    <a use:inertia href={route('users.routes', {user: $page.props.auth.user.id})} class="flex items-center group py-3">
      <Icon name="direction" class="w-5 h-5 mr-1 {isUrl('users.routes', {user: $page.props.auth.user.id}) ? 'fill-white' : 'fill-disco-200 group-hover:fill-white'} transition duration-500 ease-in-out" />
      <div class="{isUrl('users.routes', {user: $page.props.auth.user.id}) ? 'text-white' : 'text-disco-200 group-hover:text-white'} text-sm transition duration-500 ease-in-out">
        Mes trajets
      </div>
    </a>
  </div>
  <div class="mb-4">
    <a use:inertia href={route('users.solutions', {user: $page.props.auth.user.id})} class="flex items-center group py-3">
      <Icon name="event-checked" class="w-5 h-5 mr-1 {isUrl('users.solutions', {user: $page.props.auth.user.id}) ? 'fill-white' : 'fill-disco-200 group-hover:fill-white'} transition duration-500 ease-in-out" />
      <div class="{isUrl('users.solutions', {user: $page.props.auth.user.id}) ? 'text-white' : 'text-disco-200 group-hover:text-white'} text-sm transition duration-500 ease-in-out">
        Mes solutions
      </div>
    </a>
  </div>
  <div class="mb-4">
    <a use:inertia href={route('users.connections', {user: $page.props.auth.user.id})} class="flex items-center group py-3">
      <Icon name="send" class="w-5 h-5 mr-1 {isUrl('users.connections', {user: $page.props.auth.user.id}) ? 'fill-white' : 'fill-disco-200 group-hover:fill-white'} transition duration-500 ease-in-out" />
      <div class="{isUrl('users.connections', {user: $page.props.auth.user.id}) ? 'text-white' : 'text-disco-200 group-hover:text-white'} text-sm transition duration-500 ease-in-out">
        Mes messages
      </div>
    </a>
  </div>
  {#if $page.props.auth.user.type >= 3}
    <div class="mb-4">
      <a use:inertia href={route('users.solutions.search')} class="flex items-center group py-3">
        <Icon name="search" class="w-5 h-5 mr-1 {isUrl('users.solutions.search') ? 'fill-white' : 'fill-disco-200 group-hover:fill-white'} transition duration-500 ease-in-out" />
        <div class="{isUrl('users.solutions.search') ? 'text-white' : 'text-disco-200 group-hover:text-white'} text-sm transition duration-500 ease-in-out">
          Recherche
        </div>
      </a>
    </div>
  {/if}
</div>
